import React from 'react';
import { Countdown } from './Countdown';
export function UrgencyBar() {
  return <div className="sticky top-0 z-50 bg-gold text-navy font-medium text-sm py-2 px-4 text-center shadow-md" data-id="element-273">
      <p className="flex flex-wrap items-center justify-center gap-1" data-id="element-274">
        <span data-id="element-275">⏰ Precio de lanzamiento — cierra en:</span>
        <Countdown format="inline" data-id="element-276" />
        <span data-id="element-277">· Después sube $10.000. No vuelve.</span>
      </p>
    </div>;
}